import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ConfirmationService } from "primeng/api";
import { GetChatMessageListDto } from "../../../core/models/common/GetChatMessageListDto";
import { SendChatMessageRequestDto } from "../../../core/models/common/SendChatMessageRequestDto";
import { UserTagDto } from "../../../core/models/common/userTagDto";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { DocumentUploadDto } from "../../../core/models/task-management/documentUploadDto";
import { UpdateTaskRequestDto } from "../../../core/models/task-management/updateTaskDto";
import { TasksLinkFiles } from "../../../core/models/task-management/tasksLinkFiles";
import { createCommentDto } from "../../../core/models/task-management/createCommentDto";
import { CommentListDto } from "../../../core/models/task-management/getCommentList";
import { OwnersByProject } from "../../../core/models/task-management/getOwnersByProject";
import { getTaskDetailResponse } from "../../../core/models/task-management/getTaskDetailResponse";
import { GetTaskLogDto } from "../../../core/models/task-management/getTaskLogDto";
import { StatusTaskList } from "../../../core/models/task-management/statusTaskDto";
import { UpdateNotificationSetting } from "../../../core/models/task-management/updateNotificationSettingDto";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import {
  SharedService,
  getBase64,
} from "../../../core/services/shared.service";
import { TaskManagementService } from "../../../core/services/task-management.service";
import { MsalApiService } from "../../../core/services/msal-api.service";
// import { PriorityTypeEnums } from "../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { Select, SelectModule } from "primeng/select";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { CommonModule } from "@angular/common";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import {
  EditorInitEvent,
  EditorModule,
  EditorSelectionChangeEvent,
  EditorTextChangeEvent,
} from "primeng/editor";
import { TagModule } from "primeng/tag";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TaskHeaderComponent } from "../../../shared/components/task-header/task-header.component";
import { GetDocumentDto } from "../../../core/models/task-management/getDcoumentDto";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { CreateProjectOnTaskComponent } from "../create-project-on-task/create-project-on-task.component";
import { QuillLike } from "../../../core/models/common/QuillLike";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  map,
  of,
  Subject,
  take,
} from "rxjs";
import { ProjectWorkflowDetail } from "../../../core/models/task-management/getProjectWorkFlowDetailDto";
import { SelectChangeEvent } from "primeng/select";
import { PopoverModule } from "primeng/popover";
import { DividerModule } from "primeng/divider";
import { SelectButtonModule } from "primeng/selectbutton";
import { MultiSelectModule } from "primeng/multiselect";
import { ProjectWorkflowTags } from "../../../core/models/task-management/getTagsByProjectWorkflowList";
import { TaskTypeModel } from "../../../core/models/task-management/taskTypeModel";
import { DatePickerModule } from "primeng/datepicker";
import {
  getColorForName,
  getTextColorForName,
} from "../../../shared/globalfunction";
import { AvatarModule } from "primeng/avatar";
@UntilDestroy()
@Component({
  selector: "jni-task-summary",
  templateUrl: "./task-summary.component.html",
  styleUrls: ["./task-summary.component.scss"],
  providers: [ConfirmationService, DatePipe],
  imports: [
    CommonModule,
    ToggleSwitchModule,
    EditorModule,
    SelectModule,
    TagModule,
    OverlayPanelModule,
    DialogModule,
    ConfirmDialogModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ButtonModule,
    InputTextModule,
    PopoverModule,
    DividerModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
    AvatarModule,
  ],
})
export class TaskSummaryComponent implements OnInit {
  @Input() showTaskHeader!: boolean;
  @Input() taskIdSelected = 0;
  @Input() displayTaskDetailModal = false;
  @Output() closeTaskDetailModalEvent = new EventEmitter();

  priorityLevelFiltered: {
    id: number;
    title: string;
    production: boolean;
    color: string;
  }[] = [];
  displayProdWorkflowSummary = false;
  taskType = TaskTypeEnum;
  taskTypes: TaskTypeModel[] = [
    {
      id: 1,
      title: "Sales Task",
    },
    {
      id: 2,
      title: "Production Task",
    },
  ];
  taskDetail = {} as getTaskDetailResponse;
  comment = "";
  ownerList: { label: string; value: string }[] = [];
  ownerListDefault: { label: string; value: string }[] = [];
  showOwner = false;
  //userList: any;
  workflowId = 0;
  salesOrderId = "";
  chatFirstCurrentDateIndex = 0;
  messageList = [] as GetChatMessageListDto[];
  signalRChatBoxShow = false;
  displayChat = false;
  personnelNumber = "";
  userTagList = [] as UserTagDto[];
  //bacList: any[] = [];
  chatModuleName = "Proposed Project";
  @ViewChild("tagDropdown") tagDropdown!: Select;
  showTagDropdown = false;
  isTextAreaDisabled = false;
  newMessage = "";
  showSmallLoader = false;
  selectedTagId = null;
  saveMessage = "";
  paddedWorkflowId = "";
  displayOrderSummary = false;
  commentList: CommentListDto[] = [];
  selectedTaskStatus!: string;
  taskStatusList: { name: string; value: number; disabled: boolean }[] = [];
  isRedirected = false;
  isAuthorized = false;
  showAddNewProjectModal = false;
  refreshProjectList = false;
  tagsList: ProjectWorkflowTags[] = [];
  selectedTagsList: ProjectWorkflowTags[] = [];

  taskStatus: StatusTaskList[] = [
    {
      id: EnumSalesTaskStatus.New,
      status: "New",
    },
    {
      id: EnumSalesTaskStatus.Blocked,
      status: "Blocked",
    },
    {
      id: EnumSalesTaskStatus.InProgress,
      status: "In Progress",
    },
    {
      id: EnumSalesTaskStatus.InReview,
      status: "In Review",
    },
    {
      id: EnumSalesTaskStatus.Closed,
      status: "Closed",
    },
  ];
  taskStatusProd: StatusTaskList[] = [
    {
      id: WorkflowStatusEnum.ALL,
      status: "All",
    },
    {
      id: WorkflowStatusEnum.Cancelled,
      status: "Cancelled",
    },
    {
      id: WorkflowStatusEnum.Complete,
      status: "Complete",
    },
    {
      id: WorkflowStatusEnum.Delivered,
      status: "Delivered",
    },
    {
      id: WorkflowStatusEnum.InProduction,
      status: "In Production",
    },
    {
      id: WorkflowStatusEnum.OrderWritten,
      status: "Order Written",
    },
    {
      id: WorkflowStatusEnum.PoSent,
      status: "PO Sent",
    },
    {
      id: WorkflowStatusEnum.ProjectCreated,
      status: "Project Created",
    },
    {
      id: WorkflowStatusEnum.ProofApproved,
      status: "Proof Approved",
    },
    {
      id: WorkflowStatusEnum.ProofSent,
      status: "Proof Sent",
    },
    {
      id: WorkflowStatusEnum.RevisionRequested,
      status: "Revision Requested",
    },
    {
      id: WorkflowStatusEnum.Shipped,
      status: "Shipped",
    },
  ];

  priorityLevel = [
    {
      id: 1,
      title: "Urgent",
      production: true,
      color: "#FF4D4F",
    },
    {
      id: 2,
      title: "Order",
      production: false,
      color: "#F97316",
    },
    {
      id: 3,
      title: "Source",
      production: false,
      color: "#FBBC04",
    },
    {
      id: 4,
      title: "Standard",
      production: true,
      color: "#14BA6D",
    },
  ];

  deleteTagMessage = "Are you sure you want to proceed?";
  taskLogs: GetTaskLogDto[] = [];
  showScrollTop = false;
  showScrollBottom = false;
  isSummaryView = false;
  showTaskModal = false;
  displayAddTaskModal = false;
  workflowStatusList!: Record<string, number>;
  taskStatusKeyPairsSales: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progress": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };
  form!: FormGroup;
  formErrors: Record<string, string> = {};
  validationMessages: Record<string, Record<string, string>> = {
    title: {
      required: "Task is required.",
      maxlength: "Task name should not exceed 256 characters.",
    },
    project: {
      required: "Project is required.",
    },
    client: {
      required: "Client is required.",
    },
    linkedOrder: {
      required: "Linked Order is required.",
    },
    jobName: {
      required: "Job Name is required.",
    },
    ihd: {
      required: "IHD is required.",
    },
    dueDate: {
      required: "Due Date is required.",
    },
    supplier: {
      required: "Supplier is required.",
    },
    nickName: {
      required: "Nick Name is required.",
    },
    purchaseOrderNumber: {
      required: "PO# is required.",
    },
    esd: {
      required: "ESD is required.",
    },
  };
  mandotory = false;
  formType = "Add";
  notificationSwitch = true;
  isDueDateMandatory = true;
  isSalesTask = false;
  showAddTaskSmallLoader = false;
  savedTitle: string | null = null;
  addedTags: ProjectWorkflowTags[] = [];
  removedTags: ProjectWorkflowTags[] = [];
  removedDocument: DocumentUploadDto[] = [];
  addDocument: DocumentUploadDto[] = [];
  taskFileLinkList: TasksLinkFiles[] = [];
  fileObject: FileUploadDto[] = [];
  fileName = "";
  showAddTaskFileLinkModal = false;
  taskFileLinkModalHeader = "";
  taskFileLinkMode = "Add";
  taskFileLink = "";
  taskLinkName = "";
  taskFileLinkId = 0;
  documentAttachment: GetDocumentDto[] = [];

  // Project Lazy Loading Properties
  projectSearch$ = new Subject<string>();
  projectLoading = false;
  projectTotalRecords = 0;
  projectCurrentSearchTerm = "";
  projectFilterValue = "";
  projectHasMore = true;
  private projectDropdownJustOpened = false;
  projectLists: ProjectWorkflowDetail[] = [];
  selectedProject: ProjectWorkflowDetail | null = null;
  selectedChangedProject = 0;
  previousProject = 0;
  showSalesTaskProjectFieldsOverrideModal = false;
  selectedClientName = "";
  selectedCustomerAccountD365 = "";
  selectedOrderNumber = "";
  selectedBuyer = "";
  clientId = "";
  showAddBuyer = false;

  @ViewChild("taskHeader", { static: false })
  taskHeader!: TaskHeaderComponent;
  @ViewChild("createProjectOnTask", { static: false })
  createProjectOnTask!: CreateProjectOnTaskComponent;
  @ViewChild("projectSelect", { static: false })
  projectSelect!: Select;
  /** Tags selection **/
  mentionStyle: Record<string, string> = {};
  filteredOwners: { label: string; value: string }[] = [];
  private quill!: QuillLike;
  private mentionStartIndex: number | null = null;
  private mentionQuery = "";
  private isPickingMention = false;
  deleteTagVisible = false;
  deleteTagId: number | null = 0;
  displayCreateTagModal = false;
  commentUserPictures = new Map<string, string>();

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService,
    private confirmationService: ConfirmationService,
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService,
    private _samplepoListingService: SamplepoListingService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _sharedService: SharedService,
    private _formBuilder: FormBuilder,
    private _datePipe: DatePipe,
    private _msalApiService: MsalApiService
  ) {
    this._route.params.subscribe(params => {
      if (params["id"]) {
        this.isRedirected = true;
        this.taskIdSelected = parseInt(params["id"]);
        //this.isSummaryView = true; //NO Need as from email link button or task listing same popup will be displayed
      }
    });
  }

  async ngOnInit() {
    await this.defaultAssignee();
    this.initializeForm();
    this.initProjectSearch();
    this.getWorkflowStatusList();
    this.checkAuthorizedUserTask(this.taskIdSelected);
    // if (!this.isRedirected) {
    //   this.getTaskDetail();
    // } else {
    //   this.checkAuthorizedUserTask(this.taskIdSelected);
    // }
  }

  initializeForm() {
    this.form = this._formBuilder.group({
      parentTask: this._formBuilder.group({
        title: ["", [Validators.required, Validators.maxLength(256)]],
        taskType: [0],
        description: [""],
        notification: [false],
        isDateLess: [false],
      }),
      subTask: this._formBuilder.group({
        project: [0],
        client: [{ value: "", disabled: true }],
        linkedOrder: [{ value: "", disabled: true }],
        customerIdD365: [""],
        jobName: [{ value: "", disabled: true }],
        ihd: [{ value: null, disabled: true }],
        purchaseOrderNumber: [{ value: "", disabled: true }],
        supplier: [{ value: "", disabled: true }],
        esd: [{ value: null, disabled: true }],
        dueDate: [null, Validators.required],
        nickName: [""],
        priority: [0],
        assignedTo: [""],
        tag: [[]],
        remindMe: [null],
        attachment: [""],
        buyerName: [""],
        isBuyerChange: [false],
      }),
    });

    this.form
      .get("parentTask.taskType")
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(value => {
        this.setDynamicValidation(value);
      });
  }

  patchFormForEditTask() {
    const parentTaskGroup = this.form.get("parentTask");
    const subTaskGroup = this.form.get("subTask");

    if (parentTaskGroup && subTaskGroup && this.taskDetail) {
      parentTaskGroup.patchValue({
        title: this.taskDetail.title ?? "",
        taskType: this.taskDetail.taskType ?? 0,
        description: this.taskDetail.description ?? "",
        notification: this.taskDetail.isNotificationEnabled ?? false,
        isDateLess: this.taskDetail.isDateLess ?? false,
      });

      subTaskGroup.patchValue({
        project: this.taskDetail.projectWorkflowId ?? 0,
        client: this.taskDetail.clientName ?? "",
        linkedOrder: this.taskDetail.salesOrderId ?? "",
        customerIdD365: "",
        jobName: this.taskDetail.jobName ?? "",
        ihd: this.taskDetail.orderInHandDate
          ? new Date(this.taskDetail.orderInHandDate)
          : null,
        purchaseOrderNumber: this.taskDetail.purchaseOrderNumber ?? "",
        supplier: this.taskDetail.supplier ?? "",
        esd: this.taskDetail.esd ? new Date(this.taskDetail.esd) : null,
        dueDate: this.taskDetail.dueDate
          ? new Date(this.taskDetail.dueDate)
          : null,
        nickName: this.taskDetail.nickName || "",
        priority: this.taskDetail.priorityType || 0,
        assignedTo: this.taskDetail.assignedTo || "",
        tag: this.taskDetail.tags || [],
        remindMe: this.taskDetail.remindMe
          ? new Date(this.taskDetail.remindMe)
          : null,
        attachment: "",
        buyerName: this.taskDetail.buyerName || "",
        isBuyerChange: false,
      });

      this.setDynamicValidation(this.taskDetail.taskType);

      // Handle dateless tasks on load
      if (this.taskDetail.isDateLess) {
        this.clearDueDateValidationAndValue();
      }
    }
  }

  patchEmptyForm() {
    const parentTaskGroup = this.form.get("parentTask");
    const subTaskGroup = this.form.get("subTask");

    if (parentTaskGroup && subTaskGroup) {
      parentTaskGroup.patchValue({
        title: "",
        taskType: 0,
        description: "",
        notification: false,
        isDateLess: false,
      });

      subTaskGroup.patchValue({
        project: 0,
        client: "",
        linkedOrder: "",
        customerIdD365: "",
        jobName: "",
        ihd: null,
        purchaseOrderNumber: "",
        supplier: "",
        esd: null,
        dueDate: null,
        nickName: "",
        priority: 0,
        assignedTo: "",
        tag: [],
        remindMe: null,
        attachment: "",
        buyerName: "",
        isBuyerChange: false,
      });
    }
  }

  setDynamicValidation(taskType: number) {
    const subTaskGroup = this.form.get("subTask") as FormGroup;
    if (!subTaskGroup) return;

    // Clear all validators first
    Object.keys(subTaskGroup.controls).forEach(key => {
      subTaskGroup.get(key)?.clearValidators();
      subTaskGroup.get(key)?.updateValueAndValidity();
    });

    // Add dueDate validator (always required)
    subTaskGroup.get("dueDate")?.setValidators([Validators.required]);

    if (taskType === TaskTypeEnum.Production) {
      // Production Task validators
      subTaskGroup
        .get("purchaseOrderNumber")
        ?.setValidators([Validators.required]);
      subTaskGroup.get("supplier")?.setValidators([Validators.required]);
      subTaskGroup.get("esd")?.setValidators([Validators.required]);
      subTaskGroup.get("nickName")?.setValidators([Validators.required]);
      subTaskGroup.get("project")?.setValidators([Validators.required]);
      subTaskGroup.get("ihd")?.setValidators([Validators.required]);
      subTaskGroup.get("client")?.setValidators([Validators.required]);
      subTaskGroup.get("jobName")?.setValidators([Validators.required]);

      // Enable/disable fields based on production rules
      subTaskGroup.get("purchaseOrderNumber")?.enable();
      subTaskGroup.get("supplier")?.enable();
      subTaskGroup.get("esd")?.enable();
      subTaskGroup.get("ihd")?.enable();
    } else if (taskType === TaskTypeEnum.Sales) {
      // Sales Task - dynamic based on project selection
      const projectValue = subTaskGroup.get("project")?.value;

      if (projectValue && projectValue !== 0) {
        subTaskGroup.get("client")?.setValidators([Validators.required]);
        subTaskGroup.get("linkedOrder")?.setValidators([Validators.required]);
        subTaskGroup.get("jobName")?.setValidators([Validators.required]);

        // These remain disabled but required for validation
        subTaskGroup.get("client")?.disable();
        subTaskGroup.get("linkedOrder")?.disable();
        subTaskGroup.get("jobName")?.disable();
      } else {
        subTaskGroup.get("client")?.clearValidators();
        subTaskGroup.get("linkedOrder")?.clearValidators();
        subTaskGroup.get("jobName")?.clearValidators();

        subTaskGroup.get("client")?.disable();
        subTaskGroup.get("linkedOrder")?.disable();
        subTaskGroup.get("jobName")?.disable();
      }
    }

    // Update validity for all controls
    Object.keys(subTaskGroup.controls).forEach(key => {
      subTaskGroup.get(key)?.updateValueAndValidity();
    });
  }

  logValidationErrors(group: FormGroup = this.form): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      this.formErrors[key] = "";
      if (
        abstractControl &&
        !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)
      ) {
        const messages = this.validationMessages[key];

        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + " ";
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }

  getTaskDetail() {
    const taskID: number = this.taskIdSelected;
    this.showSmallLoader = true;
    this._taskManagementService
      .getTaskDetails(taskID)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.taskDetail = res.data;
          this.savedTitle = res.data.title;
          this.selectedTagsList = [...res.data.tags];
          this.taskFileLinkList = res.data.linkFiles ?? [];
          this.documentAttachment = res.data.documents ?? [];
          // Initialize taskFileLinkId counter based on existing links
          if (this.taskFileLinkList.length > 0) {
            const maxId = Math.max(
              ...this.taskFileLinkList.map(link => link.id)
            );
            this.taskFileLinkId = maxId + 1;
          }
          // Patch form with task data
          this.patchFormForEditTask();
          const status =
            res.data.taskType === TaskTypeEnum.Sales
              ? this.taskStatus.find(
                  item => res.data.status === item.id,
                  (this.taskStatusList = this.stateKeys(res.data.taskType))
                )
              : this.taskStatusProd.find(
                  item => res.data.status === item.id,
                  (this.taskStatusList = this.stateKeys(res.data.taskType))
                );
          this.getTaskLog();
          this.selectedTaskStatus = status?.status ?? "";
          this.salesOrderId = res.data.salesOrderId ?? "";
          this.workflowId = res.data.projectWorkflowId;
          this.paddedWorkflowId = res.data.projectWorkflowId?.toString();
          this.notificationSwitch = res.data.isNotificationEnabled ?? false;
          this.getComments();
          this.getOwnersByProject(res.data.client);
          this.showSmallLoader = false;
          this.isSalesTask = res.data.taskType === TaskTypeEnum.Sales;
          this.tagsList = res.data.tags;
          if (res.data.taskType === 2) {
            this.priorityLevelFiltered = this.priorityLevel.filter(
              item => item.production === true
            );
          } else {
            this.priorityLevelFiltered = this.priorityLevel;
          }

          // Load project list and ensure current project is included
          this.getAllProjectsForUsers().then(() => {
            if (res.data.projectWorkflowId) {
              const isProjectInList = this.projectLists.some(
                p => p.projectWorkflowId === res.data.projectWorkflowId
              );

              if (!isProjectInList) {
                // Add fallback project if not in initial load
                const fallbackProject: ProjectWorkflowDetail = {
                  projectWorkflowId: res.data.projectWorkflowId,
                  projectWorkflowPaddedId: this.paddedWorkflowId ?? "",
                  clientName: res.data.clientName ?? "",
                  jobName: res.data.jobName ?? "",
                  client: res.data.client ?? "",
                  salesOrderId: res.data.salesOrderId ?? "",
                  projectLabel: `${this.paddedWorkflowId} - ${res.data.clientName} - ${res.data.jobName}`,
                } as ProjectWorkflowDetail;
                this.projectLists.push(fallbackProject);
              }
            }
          });
        },
      });
  }

  getWorkflowStatusList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        this.workflowStatusList = {};
        const statusEnums: Record<string, number> = {};
        if (res?.data) {
          res.data.forEach((status: { status: string; id: number }) => {
            if (status.id !== 9) {
              statusEnums[status.status] = status.id;
            }
          });
          this.workflowStatusList = statusEnums;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  stateKeys(taskType: number) {
    const isProduction = Number(taskType) === Number(TaskTypeEnum.Production);
    const list = this._sharedService.enumToList(
      isProduction ? this.workflowStatusList : this.taskStatusKeyPairsSales
    );
    return list.map(item => ({
      ...item,
      disabled: false,
    }));
  }

  showProdWorkflowModal() {
    this.displayProdWorkflowSummary = true;
  }

  closeWorkflowModal() {
    this.displayProdWorkflowSummary = false;
  }

  showOrderModal() {
    this.displayOrderSummary = true;
  }

  closeOrderModal() {
    this.displayOrderSummary = false;
  }

  downloadFile(url: string) {
    this._sharedService.getFileAsBlob(url).subscribe({
      next: res => {
        const blob = new Blob([res], { type: res.type });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
    });
  }

  clickEdit() {
    this.redirectToEditTask(this.taskIdSelected);
  }

  // getPriorityByTitle(id: number): string {
  //   return this.priorityLevel[id];
  // }

  updateFollow() {
    this.showSmallLoader = true;
    this._taskManagementService
      .followTask(this.taskDetail.taskId, !this.taskDetail?.isFollow)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status.toLowerCase() == "success") {
            this.getTaskLog();
            if (this.taskDetail.isFollow) {
              this._toastr.success("Success", "You have unfollowed this task");
            } else {
              this._toastr.success(
                "Success",
                "You are now following this task"
              );
            }
            this.taskDetail.isFollow = !this.taskDetail.isFollow;
          }
        },
      });
  }

  getTaskLog() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getTaskLogs(this.taskDetail.taskId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status.toLowerCase() == "success") {
            this.taskLogs = res.data;
            this.taskLogs.forEach((element: GetTaskLogDto) => {
              element.log = element.log.replace("\n", "<br>");
            });
            // Check if scroll indicators are needed after data loads
            setTimeout(() => this.checkScrollIndicators(), 100);
          }
        },
      });
  }

  onScrollContainer(event: Event) {
    const element = event.target as HTMLElement;
    this.checkScrollIndicators(element);
  }

  private checkScrollIndicators(element?: HTMLElement) {
    if (!element) {
      const container = document.querySelector(".task-logs-container");
      if (!container) return;
      element = container as HTMLElement;
    }

    const { scrollTop, scrollHeight, clientHeight } = element;
    const threshold = 5; // Small threshold to account for floating point precision

    this.showScrollTop = scrollTop > threshold;
    this.showScrollBottom = scrollTop < scrollHeight - clientHeight - threshold;
  }

  checkAuthorizedUserTask(taskId: number) {
    this._loaderService.setLoaderState(true);
    this._taskManagementService
      .isAuthorizedToView(taskId.toString())
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data && res.data === true) {
            this.isAuthorized = true;
            this.getTaskDetail();
          } else {
            this.isAuthorized = false;
            this._toastr.error(
              "Error",
              "You are not authorised to view this task"
            );
            this._router.navigate(["task-management"]);
          }
        },
        error: () => {
          this.isAuthorized = false;
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error checking authorization");
        },
      });
  }

  attachmentDelConfirmation(document: GetDocumentDto, index: number) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this Attachment?",
      accept: () => {
        this.deleteAttachment(document, index);
      },
    });
  }

  tagDelConfirmation(document: number | null, index: number, title: string) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${title} Tag?`,
      accept: () => {
        this.deleteTag(document ?? 0, index);
      },
    });
  }

  async updateTaskStatus() {
    this.showSmallLoader = true;
    try {
      const status = this.taskStatusList.find(
        item => item.name == this.selectedTaskStatus
      );
      if (!status) {
        this._toastr.error("Invalid status selected", "Error");
        return;
      }
      const res = await firstValueFrom(
        this._taskManagementService
          .updateStatus(this.taskDetail.taskId, status.value)
          .pipe(take(1))
      );

      const ok = res.status.toLowerCase() === "success";
      if (!ok) {
        this._toastr.error("Error updating the status", "Error");
        return;
      }

      await firstValueFrom(this.addComment(`Status changed: ${status.name}`));
      this.getTaskLog();
      this._toastr.success(
        "You have successfully updated the Status",
        "Success"
      );
    } catch {
      this._toastr.error("Error updating the status", "Error");
    } finally {
      this.showSmallLoader = false;
    }
  }

  async sendComment(comment: string) {
    this.showSmallLoader = true;
    try {
      const ok = await firstValueFrom(this.addComment(comment));
      if (ok) this._toastr.success("Comment submitted", "Success");
      this.getTaskLog();
    } catch {
      this._toastr.error("Failed to submit comment", "Error");
    } finally {
      this.showSmallLoader = false;
    }
  }

  addComment(comment: string) {
    const commentPayload = {
      comment: comment,
      taskId: this.taskDetail.taskId,
    } as createCommentDto;
    return this._taskManagementService.addCommentinTask(commentPayload).pipe(
      take(1),
      map(res => {
        const ok = (res?.status ?? "").toLowerCase() === "success";
        if (ok) {
          this.comment = "";
          this.getComments();
        }
        return ok;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  getComments() {
    this._taskManagementService
      .getCommentsByTask(
        this.taskDetail.taskId,
        this.taskDetail.projectWorkflowId
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.commentList = res.data;
          // Load profile pictures for each unique user
          this.loadCommentUserPictures();
        },
      });
  }

  loadCommentUserPictures() {
    const uniqueEmails = [
      ...new Set(this.commentList.map(c => c.createdByEmail)),
    ];
    uniqueEmails.forEach(email => {
      if (email && !this.commentUserPictures.has(email)) {
        this.getUserProfilePicture(email);
      }
    });
  }

  getUserProfilePicture(email: string) {
    this._msalApiService
      .getUserProfilePicture(email)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: blob => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64data = reader.result as string;
            this.commentUserPictures.set(email, base64data);
          };
          reader.readAsDataURL(blob);
        },
        error: () => {
          // If picture fails to load, we'll fall back to initials
          this.commentUserPictures.set(email, "");
        },
      });
  }

  getColor(name: string) {
    return getColorForName(name);
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  getAcronym(word: string) {
    return word?.match(/\b(\w)/g)?.join("");
  }

  deleteAttachment(document: GetDocumentDto, index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .deleteDocumentFromTask(this.taskDetail.taskId, document.documentId ?? 0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getTaskLog();
          this.showSmallLoader = false;
          if (res.status.toLowerCase() === "success") {
            this.taskDetail.documents.splice(index, 1);
            this._toastr.success("Document deleted successfully", "Success");
          }
        },
      });
  }

  getOwnersByProject(client: string) {
    if (client) {
      this._samplepoListingService
        .getBCForSalesOrder(client)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.ownerList = [];
            if (res.data != null && res.data.length > 0) {
              res.data.forEach((item: GetBCForSalesOrderDto) => {
                const bcEntry = {
                  label: item.projectName,
                  value: item.projectName,
                };
                this.ownerList?.push(bcEntry);
                // Set default assignee for new tasks if this is the current logged-in user
                if (
                  item.isCurrentUser &&
                  (this.taskIdSelected === undefined ||
                    this.taskIdSelected === 0)
                ) {
                  this.form.patchValue({
                    subTask: {
                      assignedTo: item.projectName,
                    },
                  });
                }
                this.getBacForSalesOrder(item.personnelNumber);
              });
            }
          },
        });
    }
  }

  getBacForSalesOrder(personnelNumber: string) {
    this.showOwner = false;
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                const newEntry = { label: item.name, value: item.name };
                this.ownerList?.push(newEntry);
                // Set default assignee for new tasks if this is the current logged-in user
                if (
                  item.isCurrentUser &&
                  (this.taskIdSelected === undefined ||
                    this.taskIdSelected === 0)
                ) {
                  this.form.patchValue({
                    subTask: {
                      assignedTo: item.name,
                    },
                  });
                }
              }
            });
          }
          this.showOwner = true;
        },
      });
  }

  defaultAssignee(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._taskManagementService
        .getDefaultAssignees()
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data != null && res.data.length > 0) {
              res?.data.map(item => {
                if (item.name != "") {
                  const exists = this.ownerList?.some(
                    x => x.value === item.name
                  );
                  if (!exists) {
                    const newEntry = { label: item.name, value: item.name };
                    this.ownerList?.push(newEntry);
                    this.ownerListDefault?.push(newEntry);
                  }
                  // Set default assignee for new tasks if this is the current logged-in user
                  if (
                    item.isCurrentUser &&
                    (this.taskIdSelected === undefined ||
                      this.taskIdSelected === 0)
                  ) {
                    this.form.patchValue({
                      subTask: {
                        assignedTo: item.name,
                      },
                    });
                  }
                }
              });
            }
            resolve();
            this.showOwner = true;
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching Assignees");
            reject(res);
            this.showOwner = true;
          },
        });
    });
  }

  // getOwnersByProject(event: any) {
  //   this._taskManagementService
  //     .getOwnersByProject(event)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.userList = res.data;
  //         this.userTagListMapper(res.data);
  //         this.getMessagesList();
  //         res.data.map((item) => {
  //           if (item.coOwnerName != '' || item.ownerName != '') {
  //             this.ownerList.push({
  //               userId:
  //                 item.coOwnerPersonalNumber == ''
  //                   ? item.ownerPersonalNumber
  //                   : item.coOwnerPersonalNumber,
  //               name:
  //                 item.ownerName == ''
  //                   ? item.coOwnerName.replace(/\s+/g, '')
  //                   : item.ownerName.replace(/\s+/g, '')
  //             });
  //           }
  //         });
  //       }
  //     });
  // }

  getMessagesList() {
    const loaderStatus = this._loaderService.status$;
    if (!loaderStatus) {
      this._loaderService.setLoaderState(true);
    }
    this._workflowService
      .getChatMessageList(this.workflowId, "ProductionWorkflow")
      .subscribe({
        next: res => {
          if (res && res.status === "Success") {
            const today = new Date().toDateString();
            const index = res.data.findIndex(item => {
              const itemDate = new Date(item.createdDate);
              return itemDate.toDateString() === today;
            });
            if (index !== -1) {
              this.chatFirstCurrentDateIndex = index;
            }
            this.messageList = res.data;
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to get Chat Messages");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  showChatBox() {
    this.getOwnersByProject(this.taskDetail.client);
  }

  onHide() {
    this.displayChat = false;
  }

  formatMessage(message: string) {
    const regex = /@<[^,]+, ([^>]+)>/g;
    return message.replace(regex, (match, p1) => `<b>@${p1}</b>`);
    //return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  userTagListMapper(data: OwnersByProject[]) {
    const mappedList = data
      .filter(x => {
        if (x.ownerPersonalNumber || x.coOwnerPersonalNumber) {
          return true;
        }
        return false;
      })
      .map(obj => {
        const user = {} as UserTagDto;
        if (obj.ownerPersonalNumber) {
          user.name = obj.ownerName;
          user.userId = obj.ownerPersonalNumber;
          return user;
        } else {
          user.name = obj.coOwnerName;
          user.userId = obj.coOwnerPersonalNumber;
        }
        return user;
      });
    const filteredList = mappedList.filter(
      x => x.userId !== this.personnelNumber
    );
    this.userTagList.push(...filteredList);

    // const mappedBacList = this.bacList
    //   .filter(
    //     (obj) =>
    //       !this.userTagList.some(
    //         (user: UserTagDto) => user.userId === obj.personnelNumber
    //       ) && obj.personnelNumber !== this.personnelNumber
    //   )
    //   .map((obj) => {
    //     const user = {} as UserTagDto;
    //     user.name = obj.name.replace(/\s+/g, '');
    //     user.userId = obj.personnelNumber;
    //     return user;
    //   });
    // this.userTagList.push(...mappedBacList);
  }

  sendChatMessage(event: string) {
    this._loaderService.setLoaderState(true);
    if (!event) {
      this._toastr.error("Error", "Chat Message cannot be empty");
      this._loaderService.setLoaderState(false);
      return;
    }
    const payload = {} as SendChatMessageRequestDto;
    payload.moduleName = "ProductionWorkflow";
    payload.moduleId = this.workflowId.toString();
    payload.message = event;

    this._workflowService.sendChatMessage(payload).subscribe({
      next: res => {
        if (res && res.status === "Success") {
          this.getMessagesList();
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  deleteTag(tagId: number, index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .deleteTag(this.taskDetail.taskId, tagId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getTaskLog();
          this.showSmallLoader = false;
          if (res.status.toLowerCase() === "success") {
            this.taskDetail.tags.splice(index, 1);
            this._toastr.success("Tag deleted successfully", "Success");
          }
        },
      });
  }

  sendMessage() {
    if (!this.comment) {
      this._toastr.error("Add some comment to post!");
      return;
    }
    const mentionRegex = /@([\w.]+@[\w.]+\.\w+)|@(\w+)/g;
    const commentStr = this.comment.replace(
      mentionRegex,
      (match, email, mention) => {
        if (email) {
          return match;
        }
        const user = this.ownerList.find(x => x.label === mention);
        return user ? `@<${user.value}, ${user.label}>` : match;
      }
    );
    this.sendComment(commentStr);
    this.newMessage = "";
    this.saveMessage = "";
  }

  inputHandler(event: KeyboardEvent) {
    if (event.key === "@") {
      this.showTagDropdown = true;
      setTimeout(() => {
        this.tagDropdown.show();
      }, 0);
    } else {
      this.showTagDropdown = false;
    }
  }

  // onTagSelectionChange(value: string) {
  //   if (value) {
  //     this.isTextAreaDisabled = true;
  //     const user = this.ownerList.find(x => x.userId === value);
  //     this.comment = this.replaceLastOccurrence(
  //       this.comment,
  //       "@" + user?.name,
  //       "@"
  //     );
  //     this.showTagDropdown = false;
  //     this.isTextAreaDisabled = false;
  //     this.selectedTagId = null;
  //   } else {
  //     this.showTagDropdown = false;
  //   }
  // }

  replaceLastOccurrence(
    originalString: string,
    replaceString: string,
    searchString: string
  ): string {
    const lastIndex = originalString.lastIndexOf(searchString);
    if (lastIndex === -1) {
      return originalString;
    }
    const beforeLast = originalString.substring(0, lastIndex);
    const afterLast = originalString.substring(lastIndex + searchString.length);
    return beforeLast + replaceString + afterLast;
  }

  redirectToWorkflowSummary() {
    if (this.workflowId && this.salesOrderId) {
      const url = this._router.serializeUrl(
        this._router.createUrlTree([
          `/project-workflow/workflow-summary/${this.workflowId}/${this.salesOrderId}`,
        ])
      );
      window.open(url, "_blank");
    }
  }

  showAddTask() {
    this.showTaskModal = !this.showTaskModal;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  closeAddTask() {
    this.displayTaskDetailModal = false;
    this.getTaskDetail();
  }

  // saveDescription() {
  //   this.showSmallLoader = true;
  //   const payload = {
  //     taskId: this.descriptionForm.value.taskId,
  //     column: "description",
  //     value: this.descriptionForm.value.description,
  //   } as UpdateTaskLine;
  //   this._taskManagementService.UpdateTaskLine(payload).subscribe({
  //     next: async res => {
  //       if (res && res.status.toLowerCase() === "success") {
  //         this.showSmallLoader = false;
  //         this._toastr.success("Success", "Task Updated Successfully");
  //       } else {
  //         this.showSmallLoader = false;
  //         this._toastr.error("Error", "Failed to Update Task");
  //       }
  //     },
  //     error: () => {
  //       this.showSmallLoader = false;
  //       this._toastr.error("Error", "Failed to Update Task");
  //     },
  //   });
  // }

  switchNotification(event: ToggleSwitchChangeEvent) {
    this.showSmallLoader = true;
    this.notificationSwitch = event?.checked || false;
    const payload = {
      taskId: this.taskIdSelected,
      isEnabled: this.notificationSwitch,
    } as UpdateNotificationSetting;
    this._taskManagementService.updateNotificationSetting(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          this.showSmallLoader = false;
          this._toastr.success(
            "Success",
            "Notification Setting Updated Successfully"
          );
        } else {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to Update Notification Settings");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this._toastr.error("Error", "Failed to Update Notification Settings");
      },
    });
  }

  onDateLessSwitchChangeEvent(obj: ToggleSwitchChangeEvent) {
    const flag = obj?.checked ?? false;
    if (flag === true) {
      this.clearDueDateValidationAndValue();
    } else {
      this.applyValidationsToDueDate();
    }
  }

  clearDueDateValidationAndValue() {
    this.form.patchValue({
      subTask: {
        dueDate: "",
      },
    });
    const dueDateControl = this.form.get("subTask.dueDate");
    if (dueDateControl) {
      this.isDueDateMandatory = false;
      dueDateControl.clearValidators();
      dueDateControl.markAsPristine();
      dueDateControl.markAsUntouched();
      dueDateControl.setErrors(null);
      dueDateControl.disable();
      dueDateControl.updateValueAndValidity();
    }
  }

  applyValidationsToDueDate() {
    const dueDateControl = this.form.get("subTask.dueDate");
    this.isDueDateMandatory = true;
    if (dueDateControl) {
      dueDateControl.enable();
      dueDateControl.setValidators(Validators.required);
      dueDateControl.updateValueAndValidity();
    }
  }

  displayChatDialog() {
    this.displayChat = true;
    this.getMessagesList();
  }

  copyTaskFn() {
    this.confirmationService.confirm({
      message: `Are you sure you want to copy this task?`,
      accept: () => {
        this.showSmallLoader = true;
        this._taskManagementService.CopyTask(this.taskIdSelected).subscribe({
          next: async res => {
            if (res && res.status.toLowerCase() === "success") {
              this.taskDetail = res.data;
              this.taskIdSelected = res.data.taskId;
              // Patch form with copied task data
              this.patchFormForEditTask();
              const status =
                res.data.taskType === TaskTypeEnum.Sales
                  ? this.taskStatus.find(
                      item => res.data.status === item.id,
                      (this.taskStatusList = this.stateKeys(res.data.taskType))
                    )
                  : this.taskStatusProd.find(
                      item => res.data.status === item.id,
                      (this.taskStatusList = this.stateKeys(res.data.taskType))
                    );
              this.getTaskLog();
              this.selectedTaskStatus = status?.status ?? "";
              this.salesOrderId = res.data.salesOrderId ?? "";
              this.workflowId = res.data.projectWorkflowId;
              this.paddedWorkflowId = res.data.projectWorkflowId?.toString();
              this.notificationSwitch = res.data.isNotificationEnabled ?? false;
              this.getComments();
              this.getOwnersByProject(res.data.client);
              this.showSmallLoader = false;
              this.isSalesTask = res.data.taskType === TaskTypeEnum.Sales;
              this._toastr.success("Success", "Task copied successfully.");
            } else {
              this._toastr.error("Error", "Failed to copy task.");
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
            this._toastr.error("Error", "Failed to copy task.");
          },
        });
      },
    });
  }

  openAddNewProjectModal() {
    this.createProjectOnTask.clearAddNewProjectModal();
    this.showAddNewProjectModal = true;
  }

  closeAddNewProjectModal() {
    this.showAddNewProjectModal = false;
  }

  refreshProjectGrid(obj: boolean) {
    if (obj === true) {
      this.taskHeader.getAllProjectsForUsers();
    }
  }

  onEditorInit(e: EditorInitEvent) {
    this.quill = e?.editor;
  }

  onEditorTextChange(e: EditorTextChangeEvent) {
    if (!this.quill || e.source !== "user") return;

    let inserted = "";
    const d: unknown = e.delta;

    if (typeof d === "string") {
      inserted = d;
    } else if (d && typeof d === "object" && "ops" in d) {
      const ops = (d as { ops: unknown[] }).ops;
      if (Array.isArray(ops)) {
        for (const op of ops) {
          if (op && typeof op === "object" && "insert" in op) {
            const ins = (op as { insert?: unknown }).insert;
            if (typeof ins === "string") inserted += ins;
          }
        }
      }
    }

    if (!inserted) return;

    const lastChar = inserted.slice(-1);
    if (inserted.includes("@") || /[\p{L}\p{N}_-]|\s|\n/u.test(lastChar)) {
      this.updateMentionContextFromCaret();
    }
  }

  onEditorSelectionChange(e: EditorSelectionChangeEvent) {
    if (!this.quill) return;

    if (!e?.range) {
      setTimeout(() => {
        if (!this.isPickingMention) this.closeMention();
      }, 0);
      return;
    }

    this.updateMentionContextFromCaret();
  }

  updateMentionContextFromCaret() {
    const sel = this.quill.getSelection(true);
    if (!sel) return;

    const before = this.quill.getText(
      Math.max(0, sel.index - 64),
      Math.min(64, sel.index)
    );
    const m = /@([\p{L}\p{N}_-]*)$/u.exec(before);

    if (!m) {
      this.closeMention();
      return;
    }

    const query = m[1] ?? "";
    const start = sel.index - (query.length + 1);

    this.mentionStartIndex = start;
    this.mentionQuery = query;
    this.filteredOwners = this.filterOwners(query);
    const bounds = this.quill.getBounds(sel.index);
    this.mentionStyle = {
      left: `${bounds.left}px`,
      top: `${bounds.bottom}px`,
    };

    // Show + open after view updates
    if (!this.showTagDropdown) {
      this.showTagDropdown = true;
      setTimeout(() => {
        this.isPickingMention = true;
        this.tagDropdown?.show();
        this.tagDropdown?.focus();
      }, 0);
    }
  }

  closeMention() {
    this.showTagDropdown = false;
    this.selectedTagId = null;
    this.mentionStartIndex = null;
    this.mentionQuery = "";
    this.filteredOwners = [];
  }

  filterOwners(q: string): { label: string; value: string }[] {
    const s = (q || "").toLowerCase();
    return this.ownerList.filter(u => u.label.toLowerCase().includes(s));
  }

  onTagSelectionChange(selectedId: string | number | null) {
    this.isPickingMention = false;
    if (!this.quill || selectedId == null || this.mentionStartIndex == null)
      return;
    const user = this.ownerList.find(u => u.value === selectedId);
    if (!user) return;
    const replaceLen = this.mentionQuery.length + 1;
    const text = `@${user.label} `;
    this.quill.deleteText(this.mentionStartIndex, replaceLen, "user");
    this.quill.insertText(this.mentionStartIndex, text, "user");
    this.quill.setSelection(this.mentionStartIndex + text.length, 0, "user");
    this.closeMention();
  }

  beginMentionPick() {
    this.isPickingMention = true;
  }

  endMentionPick() {
    this.isPickingMention = false;
  }

  showOrHideAddTaskSmallLoader($event: boolean) {
    this.showAddTaskSmallLoader = $event;
  }

  closeTaskDetailModal() {
    this.closeTaskDetailModalEvent.emit();
  }

  trackByDocument(index: number, doc: GetDocumentDto): string {
    return doc.url || index.toString();
  }
  deletePTag(tagId: number) {
    this.deleteTagVisible = true;
    this.deleteTagId = tagId;
  }
  showCreateTagDisplay() {
    this.displayCreateTagModal = true;
  }

  configureTags() {
    const tags: ProjectWorkflowTags[] = this.taskDetail.tags || [];
    this.addedTags = tags.filter(item => !this.selectedTagsList.includes(item));
    this.removedTags = this.selectedTagsList.filter(
      item => !tags.includes(item)
    );
  }

  updateTask() {
    this.configureTags();

    // Validate form
    this.logValidationErrors();
    if (this.form.invalid) {
      this._toastr.error("Error", "Please fill in all required fields.");
      return;
    }

    this._loaderService.setLoaderState(true);

    const parentTaskValue = this.form.get("parentTask")?.value;
    const subTaskValue = this.form.get("subTask")?.value;

    const updateTaskReq = {
      taskId: this.taskDetail.taskId,
      title: parentTaskValue.title,
      description: parentTaskValue.description,
      notification: parentTaskValue.notification ?? false,
      isDateLess: parentTaskValue.isDateLess ?? false,
      dueDate:
        this._datePipe.transform(subTaskValue.dueDate, "MM/dd/yyyy") ?? null,
      priorityType: subTaskValue.priority,
      remindMe:
        this._datePipe.transform(
          subTaskValue.remindMe,
          "MM/dd/yyyy HH:mm:ss"
        ) ?? null,
      assignedTo: subTaskValue.assignedTo,
      addTaskTags:
        this.addedTags && this.addedTags.length > 0 ? this.addedTags : null,
      deleteTaskTags:
        this.removedTags && this.removedTags.length > 0
          ? this.removedTags
          : null,
      deleteDocumentsList:
        this.removedDocument.length > 0 ? this.removedDocument : null,
      addDocumentsList: this.addDocument.length > 0 ? this.addDocument : null,
      ihd: this._datePipe.transform(subTaskValue.ihd, "MM/dd/yyyy") ?? null,
      projectWorkflowId: subTaskValue.project ?? null,
      saleOrderId: this.taskDetail.salesOrderId ?? null,
      lineRecId: this.taskDetail.lineRecId ?? null,
      esd: this._datePipe.transform(subTaskValue.esd, "MM/dd/yyyy") ?? null,
      buyer: subTaskValue.buyerName ?? null,
      isBuyerChange: subTaskValue.isBuyerChange,
      linkFiles:
        this.taskFileLinkList.length > 0 ? this.taskFileLinkList : null,
      isLinkFilesUpdated: true,
      nickName: subTaskValue.nickName ?? null,
      customerIdD365:
        this.taskDetail.taskType === 1
          ? subTaskValue.customerIdD365
          : undefined,
      jobNameD365:
        this.taskDetail.taskType === 1 ? subTaskValue.jobName : undefined,
    } as UpdateTaskRequestDto;

    this._taskManagementService
      .updateTask(updateTaskReq)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() === "success") {
            if (this.savedTitle !== parentTaskValue.title) {
              this.addComment(
                `Title changed: ${parentTaskValue.title}`
              ).subscribe();
            }
            this._toastr.success("Success", "Task Updated Successfully!");
            this.getTaskDetail();
            this._loaderService.setLoaderState(false);
          } else {
            this._toastr.error("Error", "Something went wrong!");
            this._loaderService.setLoaderState(false);
          }
        },
        error: () => {
          this._toastr.error("Error", "Error editing task");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  openTaskFileLinkDailog(
    mode = "",
    file: TasksLinkFiles = {} as TasksLinkFiles
  ) {
    this.taskFileLinkModalHeader = mode + " File Link";
    this.showAddTaskFileLinkModal = true;
    this.taskFileLinkMode = mode;

    if (mode === "Edit") {
      this.taskFileLink = file.fileUrl;
      this.taskLinkName = file.fileName;
      this.taskFileLinkId = file.id;
    } else {
      this.taskFileLink = "";
      this.taskLinkName = "";
      this.taskFileLinkId = this.taskFileLinkId + 1;
    }
  }

  addTaskFileLink() {
    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (this.taskFileLink === "" || this.taskLinkName === "") {
      this._toastr.error("Error", "File Link or Name cannot be empty");
      return;
    }

    if (!urlRegex.test(this.taskFileLink.trim())) {
      this._toastr.error("Error", "Enter a valid URL");
      return;
    }

    const link: TasksLinkFiles = {
      id: this.taskFileLinkId,
      fileName: this.taskLinkName.trim(),
      fileUrl: this.taskFileLink.trim(),
      isLink: true,
      taskId: this.taskIdSelected ? this.taskIdSelected : 0,
    };

    this.taskFileLinkList.push(link);
    this.closeLinkFileLinkDailog();
  }

  editTaskFileLink() {
    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (this.taskFileLink === "" || this.taskLinkName === "") {
      this._toastr.error("Error", "File Link or Name cannot be empty");
      return;
    }

    if (!urlRegex.test(this.taskFileLink.trim())) {
      this._toastr.error("Error", "Enter a valid URL");
      return;
    }

    const obj = this.taskFileLinkList.find(x => x.id == this.taskFileLinkId);
    if (obj) {
      obj.fileName = this.taskLinkName;
      obj.fileUrl = this.taskFileLink;
    }

    this.closeLinkFileLinkDailog();
  }

  editLink(obj: TasksLinkFiles) {
    this.openTaskFileLinkDailog("Edit", obj);
  }

  deleteLink(obj: TasksLinkFiles) {
    if (obj) {
      this.taskFileLinkList = this.taskFileLinkList.filter(x => x !== obj);
    }
  }

  closeLinkFileLinkDailog() {
    this.showAddTaskFileLinkModal = false;
    this.taskFileLink = "";
    this.taskLinkName = "";
  }

  createFileUploadDto(
    base64Url: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = base64Url.split(",")[1];
    this.fileObject = [];

    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  async uploadTrackingFile(file: Event) {
    const target = file.target as HTMLInputElement;

    if (target?.files) {
      this.showSmallLoader = true;
      const fileObj = target?.files[0];
      const fileSize = Math.round(fileObj.size / 1024);
      const maxFileSize = 30 * 1024; //30 MB

      if (!fileObj) {
        this.showSmallLoader = false;
        return;
      }

      if (fileSize > maxFileSize) {
        this._toastr.error(
          "Error",
          "File size exceeds 30MB. Please upload a smaller file."
        );
        this.showSmallLoader = false;
        return;
      }

      // Define allowed file types
      const allowedTypes = [
        ".ai",
        ".esp",
        ".ppt",
        ".pdf",
        ".jpeg",
        ".jpg",
        ".eps",
        ".pptx",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".bmp",
        ".png",
      ];

      const fileExtension = "." + fileObj.name.split(".").pop()?.toLowerCase();

      if (allowedTypes.includes(fileExtension)) {
        await getBase64(fileObj).then(base64Url => {
          const base64 = base64Url as string;
          this.createFileUploadDto(
            base64,
            fileObj.name,
            fileExtension,
            fileSize,
            fileObj.type
          );
          this.fileName = fileObj.name;
          this.uploadFile(this.fileObject, this.fileObject.length - 1);
        });
      } else {
        this._toastr.error(
          "Error",
          "Invalid file type. Please upload one of the following file types: AI, ESP, PPT, PDF, JPEG, EPS, PPTX, XLSX, XLS, DOCX, DOC."
        );
        this.showSmallLoader = false;
      }
    }
  }

  uploadFile(fileObj: FileUploadDto[], index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .uploadProjectFiles(fileObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status == "Success") {
            const file = {
              name: fileObj[index].fileName,
              extension: fileObj[index].fileExtension,
              fileMimeType: fileObj[index].fileMimeType,
              size: fileObj[index].fileSize,
              url: res.data,
            };
            this.documentAttachment.push(file);
            if (this.taskIdSelected) {
              this.addDocument.push(file);
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this._toastr.error("Error", "Error uploading file");
          this.showSmallLoader = false;
        },
      });
  }

  deleteDocument(index: number) {
    const deleted = this.documentAttachment.splice(index, 1);
    if (deleted.length > 0) {
      this.removedDocument.push(deleted[0]);
    }
  }

  // Project Dropdown Methods
  initProjectSearch() {
    this.projectSearch$
      .pipe(debounceTime(300), distinctUntilChanged(), untilDestroyed(this))
      .subscribe((searchTerm: string) => {
        this.projectCurrentSearchTerm = searchTerm;
        this.projectLists = [];
        this.projectHasMore = true;
        this.loadProjectsLazy({ first: 0, rows: 10 });
      });
  }

  getAllProjectsForUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.projectLoading = true;
      const searchText = this.projectCurrentSearchTerm || "";
      this._taskManagementService
        .getProjectDetailsPaginated({
          searchText: searchText,
          skip: 0,
          take: 10,
        })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.projectLists = res.data.map(project => ({
              ...project,
              projectLabel: `${project.projectWorkflowPaddedId} - ${project.clientName} - ${project.jobName}`,
            }));
            this.projectTotalRecords = res.totalRecords ?? 0;
            this.projectHasMore =
              this.projectLists.length < this.projectTotalRecords;
            this.projectLoading = false;
            resolve();
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching Projects");
            this.projectLoading = false;
            reject(res);
          },
        });
    });
  }

  loadProjectsLazy(event: { first: number; rows: number }) {
    if (this.projectLoading || !this.projectHasMore) return;

    this.projectLoading = true;
    const skip = event.first ?? 0;
    const take = event.rows ?? 50;

    const request = {
      searchText: this.projectCurrentSearchTerm,
      skip: skip,
      take: take,
    };

    this._taskManagementService
      .getProjectDetailsPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const mappedData = res.data.map(project => ({
            ...project,
            projectLabel: `${project.projectWorkflowPaddedId} - ${project.clientName} - ${project.jobName}`,
          }));

          if (skip === 0) {
            this.projectLists = mappedData;
          } else {
            this.projectLists = [...this.projectLists, ...mappedData];
          }
          this.projectLoading = false;
          this.projectTotalRecords = res.totalRecords ?? 0;

          const hasMoreByCount =
            this.projectLists.length < this.projectTotalRecords;
          const returnedLessThanRequested = mappedData.length < take;
          this.projectHasMore = hasMoreByCount && !returnedLessThanRequested;
        },
        error: () => {
          this.projectLoading = false;
        },
      });
  }

  onProjectFilter(event: { filter: string }) {
    const filterValue = event.filter ?? "";
    this.projectFilterValue = filterValue;
    this.projectSearch$.next(this.projectFilterValue);
  }

  onProjectLazyLoad(event: { first: number; last: number }) {
    if (this.projectDropdownJustOpened) {
      return;
    }

    if (this.projectLoading || !this.projectHasMore) {
      return;
    }

    const threshold = 5;
    const shouldLoadMore = event.last >= this.projectLists.length - threshold;

    if (shouldLoadMore) {
      this.loadProjectsLazy({ first: this.projectLists.length, rows: 50 });
    }
  }

  onProjectDropdownShow() {
    this.projectDropdownJustOpened = true;
    setTimeout(() => {
      this.projectDropdownJustOpened = false;
    }, 300);

    if (this.projectSelect && this.projectFilterValue) {
      setTimeout(() => {
        this.projectSelect.filterValue = this.projectFilterValue;
        this.projectSelect.filterOptions?.filter?.();
      });
    }
  }

  onProjectChange(event: SelectChangeEvent) {
    if (!event.value) return;

    const taskType = this.form.get("parentTask.taskType")?.value;
    if (taskType !== TaskTypeEnum.Sales) {
      this.ProjectChangeEvent(event.value);
      return;
    }

    const selectedProject = this.projectLists.find(
      item => item.projectWorkflowId === event.value
    );

    if (!selectedProject) return;

    // Get current form values
    const formValues = this.form.getRawValue();
    const currentClient = formValues.subTask.client;
    const currentLinkedOrder = formValues.subTask.linkedOrder;
    const currentJobName = formValues.subTask.jobName;
    const currentIhd = formValues.subTask.ihd;
    const currentBuyerName = formValues.subTask.buyerName;

    // Check if there are changes
    const hasChanges =
      (currentClient && currentClient !== selectedProject.client) ||
      (currentLinkedOrder &&
        currentLinkedOrder !== selectedProject.salesOrderId) ||
      (currentJobName && currentJobName !== selectedProject.jobName) ||
      (currentIhd && currentIhd !== selectedProject.orderInHandDate) ||
      (currentBuyerName && currentBuyerName !== selectedProject.buyerName);

    // If there are changes and existing values, show confirmation modal
    if (
      hasChanges &&
      (currentClient ||
        currentLinkedOrder ||
        currentJobName ||
        currentIhd ||
        currentBuyerName)
    ) {
      this.selectedChangedProject = event.value;
      this.previousProject = formValues.subTask.project;
      this.showSalesTaskProjectFieldsOverrideModal = true;
    } else {
      // No changes or no existing values, apply directly
      this.ProjectChangeEvent(event.value);
    }
  }

  ProjectChangeEvent(projectId: number) {
    const selectedProject = this.projectLists.find(
      item => item.projectWorkflowId === projectId
    );

    if (!selectedProject) return;

    const subTaskGroup = this.form.get("subTask");
    if (!subTaskGroup) return;

    // Update project and related fields
    subTaskGroup.patchValue({
      project: projectId,
      client: selectedProject.clientName ?? "",
      customerIdD365: selectedProject.client ?? "",
      linkedOrder: selectedProject.salesOrderId ?? "",
      jobName: selectedProject.jobName ?? "",
      buyerName: selectedProject.buyerName ?? "",
    });

    // Handle IHD (Order In Hand Date)
    if (selectedProject.orderInHandDate) {
      const ihdDate = new Date(selectedProject.orderInHandDate);
      subTaskGroup.patchValue({
        ihd: ihdDate,
      });
    } else {
      subTaskGroup.patchValue({
        ihd: null,
      });
    }

    // Apply dynamic validation based on task type
    const taskType = this.form.get("parentTask.taskType")?.value;
    if (taskType) {
      this.setDynamicValidation(taskType);
    }

    // Close modal if open
    this.showSalesTaskProjectFieldsOverrideModal = false;
  }

  confirmProjectChange() {
    this.ProjectChangeEvent(this.selectedChangedProject);
  }

  cancelProjectChange() {
    // Revert to previous project selection
    const subTaskGroup = this.form.get("subTask");
    if (subTaskGroup) {
      subTaskGroup.patchValue({
        project: this.previousProject,
      });
    }
    this.showSalesTaskProjectFieldsOverrideModal = false;
  }

  closeSalesTaskProjectFieldsOverrideModal() {
    this.cancelProjectChange();
  }

  onProjectClear() {
    const subTaskGroup = this.form.get("subTask");
    if (subTaskGroup) {
      subTaskGroup.patchValue({
        project: 0,
      });
    }
    this.projectFilterValue = "";
    this.ownerList = this.ownerListDefault;
  }
}
